import { useId } from 'vue';

export default function useUniqueId(prefix = 'Tw_') {
  const id = useId();
  return `${prefix}${id}`;
}
